<template>
    <!--考核表单-->
    <div class="view" :style="{paddingTop:navbarheight}">
        <div class="content">
            <my-top title="日常考核" lefttext="返回" @leftclick="togo('/application/driverAssessment')"></my-top>
            <Form ref="form">
                <cell>
                    <span style="margin-right: 15px;">司机姓名: {{driverInfo.driverName}}</span><span>车牌号: {{driverInfo.carNumber || '无'}}</span>
                </cell>
                <cell v-for="(item, n) in form.list" :key="n">
                    <template #title>{{item.label}}</template>
                    <template #label>
                        <field name="checkboxGroup" v-if="item.type === 'checkbox'">
                            <template #input>
                                <checkbox-group v-model="item.result" @change="handleChange()">
                                    <div @click="toggle(n, k)"  v-for="(items, k) in item.child">
                                        <checkbox shape="square"
                                                  @click="handleClick(item, items)"
                                                  ref="checkboxes"
                                                  :name="items.option"
                                                  :key="n+'-'+k" >{{items.label}}</checkbox>
                                    </div>
                                </checkbox-group>
                            </template>
                        </field>
                        <div class="formCtn" v-else-if="item.type === 'textarea'">
                            <field v-model="item.result"
                                   rows="2"
                                   autosize
                                   show-word-limit
                                   type="textarea"
                                   maxlength="300"
                                   placeholder="请输入" @input="handleChange()"/>
                        </div>
                        计分规则：{{item.score}}
                    </template>
                </cell>
                <cell title="9，照片：非必传">
                    <template #label>
                        <UploadList :imageList="form.fileList"
                                    v-on:imageListChange="qualifiedImgListChange($event)"
                                    v-on:handleUploadStatus="UploadStatusChange($event, i)"></UploadList>
                        <div v-if="UploadError" style="color: #f00">请上传图片</div>
                    </template>
                </cell>
                <cell :title="'总分：'+form.totalScore"></cell>
            </Form>
        </div>
        <div class="btnSub">
            <van-button block type="info" :loading="loadingSub" loading-text="提交中..."  @click="handleSubmit">提交</van-button>
        </div>
    </div>
</template>

<script>
    import {Button, Cell, CellGroup, Checkbox, CheckboxGroup, Field, Form, Loading,} from "vant";
    import UploadList from "@components/UploadListVant/index.vue";
    import application from '@api/application';

    export default {
        name: "AssessmentFrom",
        components: {Cell, Form, CellGroup, Field, Button, Loading,CheckboxGroup,Checkbox,UploadList},
        data() {
            return {
                driverInfo: this.$route.query.driverInfo,
                // checkbox: false,
                checkboxGroup: [],
                UploadError:false,
                uploadStatus:false, //图片上传状态
                loadingSub:false,
                index:0,
                form:{
                    other:'',
                    fileList: [],
                    images:[],
                    totalScore:0,
                    //计算方式 总分 - 平均分数 * n
                    list: [
                        {
                            label: '1, 考勤：',
                            score: '此项共10分',
                            result:[],
                            total:10,
                            scoreNum:10,
                            curScore: 0,
                            type: 'checkbox',
                            child:[
                                {label:'是否按时上下班，遵守考勤纪律，若不能正常打卡， 须信息告知车辆管理员，否则按照公司考勤制度执行',
                                    option:'A',
                                    checked:false,
                                }
                            ]
                        },
                        {
                            label: '2, 车辆整洁：',
                            score: '此项共20分，一处未达标扣5分',
                            result:[],
                            total:20,
                            scoreNum:5,
                            curScore: 0,
                            type: 'checkbox',
                            child:[
                                {label:'1）车辆外观是否整洁；',
                                    option:'A',
                                    checked:false,},
                                {label:'2）车辆内饰是否整洁（内饰、脚垫无明显灰尘、污迹）；',
                                    option:'B',
                                    checked:false,},
                                {label:'3）车辆内是否无异味（如烟味等）；',
                                    option:'C',
                                    checked:false,},
                                {label:'4）车辆后备箱是否物品摆放整齐；',
                                    option:'D',
                                    checked:false,},
                            ]
                        },
                        {
                            label: '3, 车内物品摆放：',
                            score: '此项共20分，一处未达标扣5分',
                            result:[],
                            total:20,
                            scoreNum:5,
                            curScore: 0,
                            type: 'checkbox',
                            child: [
                                {label: '1）车内是否按7S管理要求放置了矿泉水；',
                                    option:'A',
                                    checked:false,},
                                {label: '2）车内是否有足够电源的充电宝以及供客人使用的数据线（充电宝和数据线使用完毕可以找办公室领取，但须说明出处,做好记录）；',
                                    option:'B',
                                    checked:false,},
                                {label: '3）车内是否放置了抽纸；',
                                    option:'C',
                                    checked:false,},
                                {label: '4）车内是否放置了蓝牙耳机；',
                                    option:'D',
                                    checked:false,},
                            ]
                        },
                        {
                            label: '4, 司机形象：',
                            score: '此项共计20分，一处未达标扣6分',
                            result:[],
                            total:20,
                            scoreNum:6,
                            type: 'checkbox',
                            curScore: 0,
                            child: [
                                {label: '1）是否按规范着工装；',
                                    option:'A',
                                    checked:false,},
                                {label: '2）个人形象是否得体（如胡须过长、头发过长、皮鞋是否干净）；',
                                    option:'B',
                                    checked:false,},
                                {label: '3）个人卫生是否良好（无异味）；',
                                    option:'C',
                                    checked:false,},
                            ]
                        },
                        {
                            label: '5，司机精神面貌：',
                            score: '此项共10分',
                            result:[],
                            total:10,
                            scoreNum:10,
                            curScore: 0,
                            type: 'checkbox',
                            child: [
                                {label: '1）是否前一晚不加班情况下深夜不休息，白天精神萎靡；',
                                    option:'A',
                                    checked:false,},
                            ]
                        },
                        {
                            label: '6，单据是否填写规范：',
                            score: '此项共10分，一处不合规扣5分',
                            result:[],
                            total:10,
                            scoreNum:5,
                            curScore: 0,
                            type: 'checkbox',
                            child: [
                                {label: '1）台帐是否记录及时、清楚；',
                                    option:'A',
                                    checked:false,},
                                {label: '2）行使记录单是否及时详实填写；',
                                    option:'B',
                                    checked:false,},
                            ]
                        },
                        {
                            label: '7，擦车：',
                            score: '此项共10分，一处不合规扣5分',
                            result:[],
                            total:10,
                            scoreNum:5,
                            curScore: 0,
                            type: 'checkbox',
                            child: [
                                {label: '1）洗车场洗车次数是否控制在每周不多于3次（雨季另计）；',
                                    option:'A',
                                    checked:false,},
                                {label: '2）待命期间是否主动擦车，保持车辆干净整洁；',
                                    option:'B',
                                    checked:false,},
                            ]
                        },
                        {
                            label: '8，其他加分项：非必填',
                            score: '计分规则：一次加5分，若填写了直接加5分',
                            result:[],
                            total:5,
                            scoreNum:5,
                            curScore: 0,
                            type: 'textarea',
                        },
                    ],
                },
            }
        },
        methods:{
            /**
             * 改变选项计算总分
             **/
            handleChange(e){
                let score =0 ;
                this.form.list.map(item => {
                    if(item.type === 'checkbox' && item.result.length > 0){
                        score += item.total -(item.child.length- item.result.length)*item.scoreNum;
                        item.curScore = item.total -(item.child.length- item.result.length)*item.scoreNum;
                    }else if(item.type === 'textarea' && item.result){
                        score += item.scoreNum
                        curScore = item.scoreNum
                    }else {
                        score += 0;
                    }
                });
                this.form.totalScore = score;
            },
            handleClick(item, items){
                items.checked = !items.checked
            },
            /**
             * 提交
             **/
            handleSubmit(){
                if(this.form.totalScore<=0){
                    this.$toast('请进行考核打分')
                    return false
                }
                let form ={
                  assessDetail: JSON.stringify(this.form.list),
                  driverId: this.driverInfo.driverId,
                  driverName: this.driverInfo.driverName,
                  photo: this.form.fileList.map(item =>{return item.commonId}).toString(),
                  score: this.form.totalScore
                };
                this.loadingSub = true;
                application.AddCarDriverAssess(form).then(res=>{
                    this.loadingSub = false;
                    this.$router.push({
                        path: '/application/driverAssessment',
                    })
                })
            },
            toggle(n, k) {
                let index = 0;
                for(let i=0; i<n; i++){
                    index += this.form.list[i].child.length;
                }
                index += k;
                this.$refs.checkboxes[index].toggle();
            },
            /**
             * 完成图片
             * @param $event
             */
            qualifiedImgListChange($event) {
                this.fileList = $event;
                if(this.fileList){
                    this.UploadError = false
                }
                this.form.images = $event.map((item) => {
                    return item.commonId;
                });
                this.uploadStatus=false
            },

            //上传图片状态
            UploadStatusChange($event, i){
                this.uploadStatus=$event;
            },

        },
        mounted() {
        }
    }
</script>

<style  lang="scss" scoped>
    .navbar{
        border-bottom: 1px solid #f5f5f5;
    }
    .view{
        background: #FFFFFF;
        height: calc(100vh + 1px);
        .content{
            padding-bottom: 5rem;
            .van-cell-group__title{
                color: #333333;
                /*background-color: #f5f5f5;*/
            }
        }
        .cellgroup.van-hairline--top-bottom::after{
            border:none
        }
        .van-checkbox-group>div{
            margin-bottom: 10px;
        }
        ::v-deep .van-checkbox{
            align-items: flex-start;
        }
        ::v-deep .van-checkbox__label{
            margin-top: -1px;
        }
        .formCtn{
            padding: 0 0 1rem;
            border-bottom: 0.1rem solid #f5f6f7;
            .van-field {
                padding: 0;
                &.van-cell--required::before {
                    z-index: 2;
                }
            }
            ::v-deep .van-field__value{
                background-color: #f2f2f2;
                border-radius: 4px;
                padding: 1rem 1rem 1rem 1.6rem;
            }
            ::v-deep .van-field--error .van-field__control, .van-field--error .van-field__control::placeholder{
                background-color: #FFF9E8;
            }
            ::v-deep .van-field--error .van-field__value{
                background-color: #FFF9E8;
            }
        }

        /*.cellgroup {*/
            /*.formWrap{*/
                /*.title{*/
                    /*padding:1rem 1.6rem;*/
                    /*font-size: 14px;*/
                    /*line-height: 24px;*/
                /*}*/
                /*.formCtn, .formCtn.fileToCell{*/
                    /*!*padding: 0 1.6rem 1rem;*!*/
                    /*border-bottom: 0.1rem solid #f5f6f7;*/
                    /*.van-field {*/
                        /*padding: 0;*/
                    /*}*/
                    /*::v-deep .van-field__value{*/
                        /*background-color: #f2f2f2;*/
                        /*border-radius: 4px;*/
                        /*padding: 1rem 1rem 1rem 1.6rem;*/
                    /*}*/
                    /*::v-deep .van-field--error .van-field__control, .van-field--error .van-field__control::placeholder{*/
                        /*background-color: #FFF9E8;*/
                    /*}*/
                    /*::v-deep .van-field--error .van-field__value{*/
                        /*background-color: #FFF9E8;*/
                    /*}*/
                /*}*/
                /*.formCtn.form-field{*/
                    /*display: flex;*/
                    /*padding: 1rem 1.6rem;*/
                    /*.van-field:first-child{*/
                        /*margin-right: 5px;*/
                    /*}*/
                    /*.van-field:last-child{*/
                        /*margin-left: 5px;*/
                    /*}*/
                /*}*/
                /*.formCtn.form-cell{*/
                    /*.van-cell{*/
                        /*background-color: #f2f2f2;*/
                        /*border-radius: 4px;*/
                        /*::v-deep .van-field__right-icon{*/
                            /*position: absolute;*/
                            /*right: 10px;*/
                        /*}*/
                    /*}*/
                    /*::v-deep .van-field__clear, .van-field__right-icon{*/
                        /*margin-right: 0;*/
                    /*}*/
                /*}*/
                /*.formCtn.fileToCell{*/
                    /*padding:0.3rem 1.6rem;*/
                    /*::v-deep .van-cell__title {*/
                        /*line-height: 4.2rem;*/
                    /*}*/
                    /*::v-deep .van-field__value{*/
                        /*background-color: transparent;*/
                        /*text-align: right;*/
                    /*}*/
                    /*::v-deep .van-field__value .van-field__control{*/
                        /*background-color: transparent;*/
                        /*text-align: right;*/
                    /*}*/
                /*}*/

            /*}*/

        /*}*/

        .baseInfo {
            ::v-deep .van-cell__title{
                /*min-width: 70px;*/
                /*max-width: 150px;*/
                /*margin-right: 10px;*/
                /*flex: none;*/
            }
        }
        /*.popUp{*/
            /*overflow-y: hidden;*/
            /*.popUpContent{*/
                /*position: relative;*/
                /*height: calc(100% - 44px);*/
                /*overflow-y: scroll;*/
            /*}*/
            /*.popUpNav{*/
                /*::v-deep .van-nav-bar__left .van-nav-bar__text{*/
                    /*color: #969799;*/
                /*}*/
                /*::v-deep .van-nav-bar__right .van-nav-bar__text {*/
                    /*color: #576b95;*/
                /*}*/
            /*}*/
        /*}*/
        .btn{
            .van-button{
                padding: 0;
                margin: 0;
                border-radius: 99px;
            }

        }

    }
</style>